import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createStore } from './create-store';

const DEFAULT_DISTRIBUTION_SLUG = 'pl';
const DEFAULT_DATE_RANGE: [Dayjs, Dayjs] = [
  dayjs().subtract(12, 'month').startOf('month'),
  dayjs().subtract(1, 'month').endOf('month'),
];

export interface IDistributionCostFilter {
  distributionSlug: string;
  date: [Dayjs, Dayjs];
}

type TState = {
  filters: IDistributionCostFilter;
};

type TActions = {
  setFilters: (value: IDistributionCostFilter | undefined) => void;
};

export const useDistributionCostFiltersStore = createStore<TState & TActions>(
  (set) => ({
    filters: {
      distributionSlug: DEFAULT_DISTRIBUTION_SLUG,
      date: DEFAULT_DATE_RANGE,
    },
    setFilters: (filters: IDistributionCostFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'distribution-cost-filters-store',
);
